import { gql, useMutation } from '@apollo/client';

export const mutation = gql`
  mutation ($id: String!, $data: CompanyUpdateArgs!) {
    companyUpdate(id: $id, data: $data)
  }
`;

const useCompanyUpdateMutation = () => {
  const [mutate] = useMutation(mutation);
  return { updateCompany: mutate };
};

export default useCompanyUpdateMutation;
